import { stringify } from 'query-string';
import { QueryFunction } from '@tanstack/react-query';

import { appData } from 'appData';

export type FetchListQueryParams = { [key: string]: string | string[] };

export type FetchListQueryKey = readonly [string, FetchListQueryParams?];

/**
 * `react-query` fetcher for lists of items from the Partaj API.
 */
export const fetchList: QueryFunction<any, FetchListQueryKey> = async ({
  queryKey,
}) => {
  const [name, queryParams] = queryKey;
  const response = await fetch(
    `/api/${name}/?${stringify({ ...queryParams, limit: 999 })}`,
    {
      headers: {
        'Content-Type': 'application/json',
        ...(appData.token ? { Authorization: `Token ${appData.token}` } : {}),
      },
    },
  );

  if (!response.ok) {
    throw new Error(`Failed to get list of ${name}.`);
  }

  return await response.json();
};
